<!-- Author: Wilson Pilco Nunez -->
<!-- Email: wilsonaux1@gmail.com -->
<!-- Created at: 2026-02-23 11:31 -->
<!-- Description:  -->
<template>
  <span class="badge" ref="elSpan">{{ status_name }}</span>
</template>
<script>
import {quoteBgColor} from "../quotes/quote-bg-color-directive.js"

// script content
export default {
  name: "AppointmentStatusBadge",
  components: {
    //
  },

  // directives
  directives: {
    'v-bg-color': quoteBgColor,
  },

  props: {
    status_id: {},
  },

  data: () => ({
    list: {},
    status_name: "",
  }),

  computed: {
    //
  },

  // watch: {},

  mounted() {
    let statusList = this.$store.state.config.service.quotes.status_list;
    if( statusList[this.status_id] ) {
      this.status_name = statusList[this.status_id].name;
      this.$refs.elSpan.style.backgroundColor = statusList[this.status_id].color;
    }
  },

  methods: {
    //
    //
  }
};
</script>
<style scoped></style>

